/* ISW-63 multi-level collection navigation: horizontal row scroller for sections/collection-multilevel.liquid.
 * Progressive enhancement: without this file the row still scrolls by touch, trackpad, Shift+wheel, its native scrollbar
 * and Tab; the arrow buttons stay hidden. */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('icc-mlnav-scroller')) return;
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function isFocusVisible(el) { try { return el.matches(':focus-visible'); } catch (e) { return true; } }

  class IccMlnavScroller extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.track = this.querySelector('[data-icc-mlnav-track]');
      this.prev = this.querySelector('[data-icc-mlnav-dir="-1"]');
      this.next = this.querySelector('[data-icc-mlnav-dir="1"]');
      if (!this.track || !this.prev || !this.next) return;
      this._ready = true;
      this._raf = 0;
      this._onChange = () => {
        if (this._raf) return;
        this._raf = window.requestAnimationFrame(() => { this._raf = 0; this.update(); });
      };
      this._onClick = (e) => { this.step(Number(e.currentTarget.getAttribute('data-icc-mlnav-dir'))); };
      this._onFocus = (e) => {
        const a = e.target;
        if (a && a.tagName === 'A' && this.track.contains(a) && isFocusVisible(a)) a.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      this.track.addEventListener('scroll', this._onChange, { passive: true });
      this.track.addEventListener('focusin', this._onFocus);
      this.prev.addEventListener('click', this._onClick);
      this.next.addEventListener('click', this._onClick);
      if ('ResizeObserver' in window) {
        // The track is full width, so its own box rarely changes; observe the items too, so a late
        // web-font swap (head_assets.liquid loads Google Fonts async with display=swap) re-runs update().
        this._ro = new ResizeObserver(this._onChange);
        this._ro.observe(this.track);
        this.track.querySelectorAll('li').forEach((li) => this._ro.observe(li));
      } else window.addEventListener('resize', this._onChange);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onChange);
      this.update();
    }
    disconnectedCallback() {
      if (!this._ready) return;
      this._ready = false;
      this.track.removeEventListener('scroll', this._onChange);
      this.track.removeEventListener('focusin', this._onFocus);
      this.prev.removeEventListener('click', this._onClick);
      this.next.removeEventListener('click', this._onClick);
      if (this._ro) this._ro.disconnect(); else window.removeEventListener('resize', this._onChange);
      if (this._raf) window.cancelAnimationFrame(this._raf);
      this._raf = 0;
    }
    update() {
      if (!this._ready) return;  // a late fonts.ready (or rAF) after disconnect is a no-op
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const x = Math.abs(t.scrollLeft);
      const p = max > 1 && x > 1;
      const n = max > 1 && x < max - 1;
      // Show before hide: a focused button that hides hands focus to the other one only if that one is already
      // visible (one prev press can jump from the end straight to the start, e.g. under reduced motion).
      if (p) { this.setButton(this.prev, p, this.next); this.setButton(this.next, n, this.prev); }
      else { this.setButton(this.next, n, this.prev); this.setButton(this.prev, p, this.next); }
    }
    setButton(btn, on, other) {
      if (btn.hidden === !on) return;
      const hadFocus = document.activeElement === btn;
      btn.hidden = !on;
      if (hadFocus && !on) {
        const target = other.hidden ? this.visibleLink() : other;
        if (target) target.focus({ preventScroll: true });
      }
    }
    visibleLink() {
      const tr = this.track.getBoundingClientRect();
      const links = this.track.querySelectorAll('a');
      for (let i = 0; i < links.length; i++) {
        const r = links[i].getBoundingClientRect();
        if (r.left >= tr.left && r.right <= tr.right) return links[i];
      }
      return links[0] || null;
    }
    step(dir) {
      const t = this.track;
      t.scrollBy({ left: dir * Math.max(t.clientWidth * 0.8, 80), behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth' });
    }
  }
  window.customElements.define('icc-mlnav-scroller', IccMlnavScroller);
})();
